import React, {Component} from 'react';
import '../../pages/settingsPage/SettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import models from '../../model/models';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import BloodCommUuidCard from "../../cards/bloodCommUuidCard/BloodCommUuidCard";
import SettingsTabBar from '../../components/settingsTabBar/SettingsTabBar';

export default class SensorsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_group: {},
		};
	}

	componentDidMount = async () => {
		this.subscribeId = models.user_group.onChange(this._getData);
		await this._getData();
	};

	componentWillUnmount = () => {
		if (this.subscribeId) {
			models.user_group.unsubscribe(this.subscribeId);
		}
	};

	_getData = async () => {
		let user_group = models.user_group.obj();
		if (!user_group) return;
		await userGroupSettingsManager.refresh(user_group.id);
		this.setState({user_group});
	};

	render() {
		return (
			<Page className="g-settings-page">
				<Card>
					<Label larger black>
						Account settings
					</Label>
					<div className="lower">
						<SettingsTabBar userGroup={this.state.user_group} />
						<BloodCommUuidCard />
					</div>
				</Card>
			</Page>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/sensorsPage/SensorsPage.jsx